import Helper from "../../src/support/Helper";

class Profile {
    static PROFILE_ACCOUNT_INFORMATION = Helper.getProfileUrl() + '/api/user/user/profile';

    static getProfileAccountInformationPageRouteURL() {
        return '/profile';
    }
}

export default Profile;